module.exports = __webpack_public_path__ + "img/img02.3f0e85d5.png";